import { Loader } from "@react-gcc-eds/core";
import { useEffect } from "react";

const REDIRECT_MESSAGE = "ECOD has moved. You will be redirected to the new address shortly.";
const REDIRECT_TARGET_URL = "https://customerorderdashboard.ericsson.net";

const RedirectToNewAddressView = () => {
  useEffect(() => {
    const tmo = setTimeout(() => {
      window.location.replace(REDIRECT_TARGET_URL);
    }, 10000);
    return () => clearTimeout(tmo);
  }, []);

  return (
    <div className="dark">
      <main className="redirect-container">
        <div className="signin redirect-logo">
          <div className="watermark">
            <i className="icon icon-econ" />
            <div className="product">Ericsson Customer Order Dashboard</div>
          </div>
        </div>
        <div className="redirect-progress">
          <div className="redirect-text">{REDIRECT_MESSAGE}</div>
          <a href={REDIRECT_TARGET_URL}>{REDIRECT_TARGET_URL}</a>
          <Loader size="small" />
        </div>
        <div className="redirect-placeholder"></div>
      </main>
    </div>
  );
};

export default RedirectToNewAddressView;
